import {
	LOAD_ALL,
	RESET_ALL
} from '../actions/residentialAreaAction'

const initialState = {
	all: [],
};

const reducer = (state = initialState, action) => {
	var nextState = {};
	switch (action.type) {
		case LOAD_ALL:
			nextState = Object.assign({}, state)
			nextState.all = action.data;

			return nextState
		case RESET_ALL:
			nextState = Object.assign({}, state)
			nextState.all = []

			return nextState
		default:
			return state
	}
};

export default reducer;